import React from 'react';
import { useDispatch } from 'react-redux';
import { FormattedDate } from 'react-intl';
import {
	Button,
	DialogContent,
	DialogTitle,
	DialogActions,
	TableContainer,
	Table,
	TableRow,
	TableCell,
	TableBody,
	Paper
} from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { ButtonLink, useSettings, Utils } from 'app/main/components';

interface DemsRecipientsClickDetailsDialogProps {
	clicks: any[];
}

export function showDemsRecipientsClickDetailsDialog(props: DemsRecipientsClickDetailsDialogProps) {
	return openDialog({
		children: <DemsRecipientsClickDetailsDialog {...props} />,
		maxWidth: 'md',
		fullWidth: true
	});
}

export default function DemsRecipientsClickDetailsDialog({ clicks }: DemsRecipientsClickDetailsDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	return (
		<>
			<DialogTitle>{t('DIALOG_TITLE_RECIPIENTS_CLICK_DETAILS')}</DialogTitle>
			<DialogContent>
				<TableContainer component={Paper} variant="outlined">
					<Table className="tabular-nums" size="small">
						<TableBody>
							{clicks.map(click => (
								<TableRow
									key={click.dclk_uid}
									sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
								>
									{!!click.dclk_ip && <TableCell>{click.dclk_ip}</TableCell>}
									{!!click.dclk_date && (
										<TableCell align="right">
											<FormattedDate
												value={Utils.parseDate(click.dclk_date)?.toDate()}
												year="numeric"
												month="numeric"
												day="numeric"
												hour="numeric"
												minute="numeric"
												second="numeric"
											/>
										</TableCell>
									)}
									<TableCell>
										{<ButtonLink href={click.durl_url}>{click.durl_url}</ButtonLink>}
									</TableCell>
									<TableCell align="right">x{click.dclk_count}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_CLOSE')}</Button>
			</DialogActions>
		</>
	);
}
